<template>
  <div>
    <v-row class="fill-height">
      <v-col>
        <v-sheet height="64">
          <v-toolbar flat>
            <v-btn
              outlined
              class="mr-4"
              color="grey darken-2"
              @click="setToday"
            >
              Today
            </v-btn>
            <v-btn fab text small color="grey darken-2" @click="prev">
              <v-icon small> mdi-chevron-left </v-icon>
            </v-btn>
            <v-btn fab text small color="grey darken-2" @click="next">
              <v-icon small> mdi-chevron-right </v-icon>
            </v-btn>
            <v-toolbar-title v-if="$refs.calendar">
              {{ $refs.calendar.title }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-menu bottom right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on">
                  <span>{{ typeToLabel[type] }}</span>
                  <v-icon right> mdi-menu-down </v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="type = 'day'">
                  <v-list-item-title>Dan</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = 'week'">
                  <v-list-item-title>Tjedan</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = 'month'">
                  <v-list-item-title>Mjesec</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = '4day'">
                  <v-list-item-title>4 dana</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-toolbar>
        </v-sheet>
        <v-sheet height="600">
          <v-calendar
            ref="calendar"
            v-model="focus"
            color="primary"
            :events="events"
            :event-color="getEventColor"
            :type="type"
            @click:event="showEvent"
            @click:more="viewDay"
            @click:date="viewDay"
            @change="getCallendar"
          ></v-calendar>
          <v-menu
            v-model="selectedOpen"
            :close-on-content-click="false"
            :activator="selectedElement"
            offset-x
          >
            <v-card color="grey lighten-4" min-width="350px" flat>
              <v-toolbar :color="selectedEvent.color" dark>
                <v-btn icon>
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon>
                  <v-icon>mdi-heart</v-icon>
                </v-btn>
                <v-btn icon>
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <span v-html="selectedEvent.details"></span>
              </v-card-text>
              <v-card-actions>
                <v-btn text color="secondary" @click="selectedOpen = false">
                  Cancel
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
        </v-sheet>
      </v-col>
      <v-btn @click="getCalendar()">Dohvati</v-btn>
      <!-- <v-btn @click="putInCalendar()">Dodaj Default</v-btn> -->
    </v-row>
    <v-dialog v-model="dialog" max-width="500px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
          Novi događaj
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">Novi događaj</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="6" sm="6" md="4">
                <v-checkbox label="Plaćena najamnina"></v-checkbox>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close"> Otkaži </v-btn>
          <v-btn color="blue darken-1" text @click="save"> Spremi </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import calendarAPI from "../../apiCallers/calendarSharepoint";
export default {
  props: {
    accessToken: {
      type: String,
      required: true,
      default: null,
    },
  },
  data: () => ({
    focus: "",
    type: "month",
    typeToLabel: {
      month: "Month",
      week: "Week",
      day: "Day",
      "4day": "4 Days",
    },
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    events: [],
    colors: [
      "blue",
      "indigo",
      "deep-purple",
      "cyan",
      "green",
      "orange",
      "grey darken-1",
    ],
    names: [
      "Meeting",
      "Holiday",
      "PTO",
      "Travel",
      "Event",
      "Birthday",
      "Conference",
      "Party",
    ],

    newEvent: {
      subject: "Planiranje Secret Sante.",
      body: {
        contentType: "HTML",
        content: "Moramo krenuti planirati secret santu!",
      },
      start: {
        dateTime: "2021-02-10T11:00:00",
        timeZone: "Europe/London",
      },
      end: {
        dateTime: "2021-02-10T12:00:00",
        timeZone: "Europe/London",
      },
      attendees: [
        {
          emailAddress: {
            address: "goran@greaties.com",
            name: "Goran Vrban",
          },
          type: "Required",
        }
      ],
      location: {
        displayName: "Konferencijska soba 3, Browncatz d.o.o.",
        locationType: "Default",
      },
      locations: [
        {
          displayName: "Conf Room 3",
        },
        {
          displayName: "Jalkovečka 2",
          address: {
            street: "Jalkovečka 2",
            city: "Varaždin",
            state: "Varazdinska",
            countryOrRegion: "CRO",
            postalCode: "42000",
          },
          coordinates: {
            latitude: 46.30200855519746, 
            longitude: 16.332245584966742
          },
        },
        {
          displayName: "Home Office",
        },
      ],
      allowNewTimeProposals: true,
    },
  }),
  mounted() {
    this.$refs.calendar.checkChange();
  },
  methods: {
    putInCalendar()
    {
      calendarAPI.addEventToCalendar(this.accessToken,this.$route.params.uid, this.newEvent)
    },
    getCalendar() {
      console.log(this.accessToken);
      console.log(this.$route.params.uid);
      var events = []

      calendarAPI.getCallendar(this.accessToken, this.$route.params.uid).then((response)=>{
        console.log(response.data.value)
        response.data.value.forEach((ev)=>{
          console.log(ev)
          events.push({
          name: ev.subject,
          start: new Date(ev.start.dateTime),
          end: new Date(ev.end.dateTime),
          color: this.colors[3],
          timed:true
        });
        })
        this.events = events;
        
      });
      
    },
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        setTimeout(() => {
          this.selectedOpen = true;
        }, 10);
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    updateRange({ start, end }) {
      const events = [];
      const min = new Date(`${start.date}T00:00:00`);
      const max = new Date(`${end.date}T23:59:59`);
      const days = (max.getTime() - min.getTime()) / 86400000;
      const eventCount = this.rnd(days, days + 20);

      // for (let i = 0; i < eventCount; i++) {
      //   const allDay = this.rnd(0, 3) === 0;
      //   const firstTimestamp = this.rnd(min.getTime(), max.getTime());
      //   const first = new Date(firstTimestamp - (firstTimestamp % 900000));
      //   const secondTimestamp = this.rnd(2, allDay ? 288 : 8) * 900000;
      //   const second = new Date(first.getTime() + secondTimestamp);

      //   events.push({
      //     name: this.names[this.rnd(0, this.names.length - 1)],
      //     start: first,
      //     end: second,
      //     color: this.colors[this.rnd(0, this.colors.length - 1)],
      //     timed: !allDay,
      //   });
      // }
      calendarAPI.getCallendar(this.accessToken, this.$route.params.uid).then((response)=>{
        console.log(response.data.value)
      });
      

      this.events = events;
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },
  },
};
</script>

<style>
</style>